<template>
  <div id="app-inside">
    <textPage v-if='textPage !== null'></textPage>
    <spotdistance v-if="this.$store.state.spotAtDistance !== null && ($route.name === 'map' || $route.name ==='profile')" v-bind:spot='this.$store.state.spotAtDistance'></spotdistance>
    <errupt v-if="locationError && currentRoute !== 'start'"></errupt>
    <interupt v-if="interupt !== null"></interupt>
    <!--<highscore v-if="highscore === true"></highscore>-->
    <location v-if="$route.name !== 'start' && $route.name !== 'tutorial'"></location>
    <auth></auth>
    <info-menu v-if="infoMenu"></info-menu>
    <photo v-if="singlePhoto !== null"></photo>
    <photo-upload v-if="showingPhotoUpload"></photo-upload>
    <spot v-if="showingOverlay === true" v-show="showingPhotoUpload === false"></spot>
    <router-view v-if="textPage === null"></router-view>
    <!--<div class="menu" v-if="showMenu">
      <router-link to="/map" class="menu-map"></router-link>
      <router-link v-if="user !== null" to="/battle" class="menu-battle"></router-link>
      <router-link v-if="user !== null" to="/profile" class="menu-profile"></router-link>
      <router-link v-if="user === null" to="/profile" class='menu-text'>LOGIN</router-link>
      <router-link to="/ar" class="menu-ar"></router-link>
    </div>-->
    <transition name="slide-rotate-fade">
      <div class='float-toggle' v-if="showMenu === false && $route.name === 'map'" v-on:click="$store.commit('changeShowMenu', true)"></div>
    </transition>
    <!--<transition name="slide-fade">
      <router-link class='inside-closer' v-if="$route.name !== 'map'" to="/">✖</router-link>
    </transition>-->
    <float-menu v-if="showMenu === true && $route.name === 'map'"></float-menu>
  </div>
</template>

<script>
import location from '@/components/Location'
import auth from '@/components/Auth'
import spot from '@/components/spot'
import photoUpload from '@/components/PhotoUpload'
//  import battle from '@/components/Battle'
//  import battleData from '@/components/BattleData'
import interupt from '@/components/Interupt'
import errupt from '@/components/errupt'
import photo from '@/components/photo'
import infoMenu from '@/components/infoMenu'
import floatMenu from '@/components/FloatMenu'
import textPage from '@/components/Textpage'
import spotdistance from '@/components/Spotdistance'
//  import highscore from '@/components/Highscore'

export default {
  name: 'app',
  data () {
    return {
      currentRoute: null
    }
  },
  computed: {
    highscore () {
      return this.$store.state.highscore
    },
    showMenu () {
      return this.$store.state.showMenu
    },
    user () {
      return this.$store.state.user
    },
    textPage () {
      return this.$store.state.textPageContent
    },
    interupt () {
      return this.$store.state.interupt
    },
    showingOverlay () {
      return this.$store.getters.showingOverlay
    },
    showingPhotoUpload () {
      return this.$store.state.showingPhotoUpload
    },
    locationError () {
      return this.$store.state.locationError
    },
    singlePhoto () {
      return this.$store.state.singlePhoto
    },
    infoMenu () {
      return this.$store.state.infoMenu
    }
  },
  watch: {
    '$route' (val) {
      this.currentRoute = val.name
    }
  },
  mounted () {
    this.$store.dispatch('fetchAreasFromApi')
    this.currentRoute = this.$router.currentRoute.name
    //  this.$store.commit('interupt', { html: 'Du vann!<h6>Testar type = win</h6><h5>+50 poäng</h5>', type: 'win' })
  },
  components: { location, auth, spot, photoUpload, interupt, errupt, photo, infoMenu, floatMenu, textPage, spotdistance }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  min-height: 100%;
  color: #fff;
  font-size: 20px;
  -webkit-tap-highlight-color:  rgba(255, 255, 255, 0); 
}
a {
  font-family: "jaf-domus", Helvetica, Arial, sans-serif;
  color: #fff;
  text-decoration: none;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
#app-inside {
  font-family: "jaf-domus", Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  min-height: 100%;
  font-weight: 300;
}
#app h1 {
  color: #000;
}
.view {
  width: 100%;
  position: relative;
  box-sizing: border-box
}
.view .sub-heading {
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 4px;
}
.sub-heading-list {
  box-sizing: border-box;
  padding: 0px 15px;
}
.sub-heading-list .sub-heading {
  float: left;
}
.sub-heading-list .text {
  float: right;
}
.sub-heading-list .border {
  height: 5px;
  width: 100%;
  border-bottom: 1px solid #fff;
  margin-bottom: 20px;
  clear: both;
}
.view .heading {
  font-size: 30px;
  padding: 5px 0px;
  letter-spacing: 1px;
}
.menu {
  position: absolute;
  position: fixed;
  bottom: 0px;
  padding: 0px;
  height: 62px;
  width: 100%;
  z-index: 99;
  background-color: #fff;
  vertical-align: middle;
  line-height: 62px;
  border-top: 1px solid #e6e6e6;
  display: table;
}  
.float-toggle {
  position: fixed;
  bottom: 20px;
  left: 50%;
    margin-left: -35px;
    width: 66px;
    height: 66px;
    border-radius: 66px;
    z-index: 99;
    line-height: 66px;
    cursor: pointer;
    background-color: #272264;
    /* background-color: #2962FF; */
    border: 2px solid #4d4dc1;
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;          /* Likely future */  
    background-size: 35.5px;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url('./assets/float/ryggdark.svg');
  }
  .inside-closer {
    height: 46px;
    width: 46px;
    position: fixed;
    bottom: 30px;
    left: 50%;
    font-size: 30px;
    line-height: 46px;
    margin-left: -23px;
    z-index: 5;
    border-radius: 46px;
    cursor: pointer;
    color: #272264;
    background-color: #e6e6e6;
    border: 1px solid #d8d8d8;
  }

.menu a {
  display: table-cell;
  background-size: 33px;
  background-repeat: no-repeat;
  background-position: center center;
  vertical-align: middle;
  height: 100%;
  line-height: 62px;
  width: 25%;
}
.content {
  width: 100%;
  max-width: 1000px;
  margin: auto;
  box-sizing: border-box;
  padding: 5px;
}
.menu a.menu-map {
  background-image: url('./assets/map_off.svg');
}
.menu a.menu-map:hover, .menu a.menu-map.router-link-active {
  background-image: url('./assets/map_on.svg');
}
/*
.menu a.menu-map:not(:active) {
  -webkit-animation-name: clickAnimation;
  -webkit-animation-duration:0.3s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards;
} */
.menu a.menu-ar {
  background-size: 43px;
  background-image: url('./assets/ar_off.svg');
}
.menu a.menu-ar:hover, .menu a.menu-ar.router-link-active {
  background-image: url('./assets/ar_on.svg');
}
/*
.menu a.menu-ar:not(:active) {
  -webkit-animation-name: clickAnimation;
  -webkit-animation-duration:0.3s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards;
}
*/
.menu a.menu-profile {
  background-size: 26px;
  background-image: url('./assets/profile_off.svg');
}
.menu a.menu-profile:hover, .menu a.menu-profile.router-link-active {
  background-image: url('./assets/profile_on.svg');
}
/*
.menu a.menu-profile:not(:active)  {
  -webkit-animation-name: clickAnimation;
  -webkit-animation-duration:0.3s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards;
}
*/
.menu a.menu-battle {
  background-size: 31px;
  background-image: url('./assets/battle_off.svg');
}
.menu a.menu-battle:hover, .menu a.menu-battle.router-link-active {
  background-image: url('./assets/battle_on.svg');
}

/*
.menu a.menu-battle:not(:active) {
  -webkit-animation-name: clickAnimation;
  -webkit-animation-duration:0.3s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -webkit-animation-fill-mode: forwards;
}
*/
@-webkit-keyframes clickAnimation {
  from {
    -webkit-transform: scale(1.3);
  }
  to {
    -webkit-transform: scale(1);
  }
}
.menu-text {
  text-transform: uppercase;
  font-size: 15px;
  letter-spacing: 2px;
  color: grey;
}
.view-switch-enter-active, .view-switch-leave-active {
  transition: opacity .5s;
}
.view-switch-enter, .view-switch-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.blue-butt {
  border-radius: 50px;
  background-color: #2962FF;
  border: 1px solid #2962FF;
  color: #fff;
  padding: 9px 40px;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
  font-size: 20px;
  font-weight: normal;
}
.blue-butt:active {
  background-color: #6ca1ff;
}
.white-on-black-butt {
  width: 100%;
  border-radius: 50px;
  background-color: transparent;
  color: #fff;
  padding: 13px;
  border: 2px solid #fff;
  box-sizing: border-box;
  max-width: 340px;
  display: inline-block;
  cursor: pointer;
  font-size: 20px;
}
.white-on-black-butt:active {
  background-color: #6ca1ff;
}
.black-on-white-butt {
  border-radius: 50px;
  background-color: transparent;
  padding: 9px 40px;
  color: #2c3e50;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
  font-size: 20px;
  background-color: #e6e6e6;
  font-weight: normal;
}
.black-on-white-butt:active {
  background-color: #6ca1ff;
}
/* Padding */

.padding-40 {
  padding-top: 40px;
}
.padding-20 {
  padding-top: 20px;
}
.padding-80 {
  padding-top: 80px;
}
.margin-20 {
  margin-top: 20px;
}
.margin-40 {
  margin-top: 40px;
}
.body-heading {
  font-size: 24px;
  margin: 5px;
  letter-spacing: 1px;
}
.close-but {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 30px;
  z-index: 99;
  cursor: pointer;
}
.back-but {
  position: absolute;
  top: 18px;
  left: 14px;
  width: 26px;
  height: 26px;
  font-size: 28px;
  background-image: url('./assets/back.svg');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.blue-circle {
  height: 7px;
  width: 7px;
  display: inline-block;
  border-radius: 10px;
  border: 2px solid #2f4efd;
}
.blue {
  color: #2f4efd;
}
.view .heading .blue-circle {
  line-height: 30px;
}
.pad-sides {
  padding-left: 15px;
  padding-right: 15px;
}
.a-left {
  text-align: left
}
.info-text {
  opacity: 0.5;
  font-size: 0.9em;
}
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for <2.1.8 */ {
    transform-origin: 0 0;
    transform: translateY(30px);
    opacity: 0;
  }
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-rotate-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-rotate-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-rotate-fade-enter, .rotate-leave-to
  /* .slide-fade-leave-active for <2.1.8 */ {
    transform: translateY(90px) rotate(90deg) ;

    opacity: 0;
  }

  /* App smile icons */
  .smile {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .smile-sun {
    height: 110px;
    width: 110px;
    background-image: url('./assets/clipart/sun.svg');
  }
  .smile-key {
    height: 140px;
    width: 140px;
    background-image: url('./assets/clipart/key.svg');
  }
  .smile-camera {
    height: 70px;
    width: 70px;
    transform: rotate(-3deg);
    background-image: url('./assets/clipart/camera.svg');
  }
  .smile-squares {
    height: 70px;
    width: 70px;  
    background-image: url('./assets/clipart/squares.svg');
  }
  .smile-crop {
    height: 70px;
    width: 70px;  
    background-image: url('./assets/clipart/crop.svg');
  }
  .smile-levers {
    height: 60px;
    width: 60px;
    background-image: url('./assets/clipart/test.svg');
  }
  .smile-crown {
    height: 70px;
    width: 70px;  
    background-image: url('./assets/clipart/crown.svg');
  }
</style>



// WEBPACK FOOTER //
// App.vue?83f7bc82